// extracted by mini-css-extract-plugin
export var formContainer = "_mg-0";
export var message = "_mg-1";